import styled from 'styled-components';
import { IButtonProps,  } from '../interfaces';
import { theme } from '../theme';
const { common, secondary, accent, background, info, danger } = theme.palette;


export const Button = styled.button<IButtonProps>`
  font-style: normal;
  font-weight: ${props => props.fontWeight};
  font-size: ${props => props.fontSize};
  line-height: ${props => props.lineHeight};
  text-align: center;
  letter-spacing: normal;
  color: ${props => props.color || common.black};
  background: ${props => props.bgColor || background.transparent};
  border-radius: ${props => props.borderRadius};
  height: ${props => props.height};
  min-height: ${props => props.minHeight};
  display: inline-block;
  box-shadow: none;
  outline: none;
  min-width: ${props => props.minWidth};
  padding: ${props => props.padding};
  border: 1px solid ${props => props.borderColor};
  transition: all 0.3s;
  &:hover,
  &:focus {
    cursor: pointer;
    transition: all 0.3s;
  }
  &:disabled,
  &[disabled] {
    cursor: not-allowed;
    opacity: 0.65;
  }
`;
Button.defaultProps = {
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '14px',
  borderRadius: '4px',
  height: '30px',
  minWidth: '150px',
  minHeight: '20px',
  padding: '8px 15px', 
  borderColor: background.transparent,
};

export const BlueButton = styled(Button)<IButtonProps>`
  box-sizing: border-box;
  cursor: pointer;
  background: ${props => (props.primary ? secondary.light : common.white)};
  color: ${props => (props.primary ? common.white : secondary.light)};
  border: 1px solid ${secondary.light};

  &:focus,
  &:hover {
    background: ${props => (props.primary ? common.white : secondary.light)};
    color: ${props => (props.primary ? secondary.light : common.white)};
  }
`;

export const OrangeButton = styled(Button)<IButtonProps>`
  box-sizing: border-box;
  border: 1px solid ${accent.dark};
  background: ${props => (props.primary ? accent.dark : common.white)};
  color: ${props => (props.primary ? common.white : accent.dark)};
  cursor: pointer;

  &:hover,
  &:focus {
    background: ${props => (props.primary ? common.white : accent.dark)};
    color: ${props => (props.primary ? accent.dark : common.white)};
  }
`;
export const RedButton = styled(Button)<IButtonProps>`
  box-sizing: border-box;
  border: 1px solid ${danger.dark};
  background: ${props => (props.primary ? danger.dark : common.white)};
  color: ${props => (props.primary ? common.white : danger.dark)};
  cursor: pointer;

  &:hover,
  &:focus {
    background: ${props => (props.primary ? common.white : danger.dark)};
    color: ${props => (props.primary ? danger.dark : common.white)};
  }
`;
export const SoftRedButton = styled(Button)<IButtonProps>`
  box-sizing: border-box;
  border: 1px solid #e5685e;
  background: ${props => (props.primary ? '#E5685E' : '#fff')};
  color: ${props => (props.primary ? '#fff' : '#E5685E')};
  cursor: pointer;

  &:hover,
  &:focus {
    background: ${props => (props.primary ? '#fff' : '#E5685E')};
    color: ${props => (props.primary ? '#E5685E' : '#fff')};
  }
`;

export const SapphireBlueButton = styled(Button)<IButtonProps>`
  box-sizing: border-box;
  border: 1px solid ${info.dark};
  background: ${props => (props.primary ? info.dark : common.white)};
  color: ${props => (props.primary ? common.white : info.dark)};
  cursor: pointer;

  &:hover,
  &:focus,
  &:active {
    background: ${props => (props.primary ? common.white : info.dark)};
    color: ${props => (props.primary ? info.dark : common.white)};
  }
`;
export const MadisonBlueButton = styled(Button)<IButtonProps>`
  box-sizing: border-box;
  border: 1px solid ${info.darker};
  background: ${props => (props.primary ? info.darker : common.white)};
  color: ${props => (props.primary ? common.white : info.darker)};
  cursor: pointer;

  &:hover,
  &:focus {
    background: ${props => (props.primary ? common.white : info.darker)};
    color: ${props => (props.primary ? info.darker : common.white)};
  }
`;
export const SoftPurpleButton = styled(Button)<IButtonProps>`
  box-sizing: border-box;
  border: 1px solid #6c69ca;
  background: ${props => (props.primary ? '#6C69CA' : common.white)};
  color: ${props => (props.primary ? common.white : '#6C69CA')};
  cursor: pointer;

  &:hover,
  &:focus {
    background: ${props => (props.primary ? common.white : '#6C69CA')};
    color: ${props => (props.primary ? '#6C69CA' : common.white)};
  }
`;
export const ActiveInactiveButton = styled(Button)<IButtonProps>`
  box-sizing: border-box;
  border: 1px solid transparent;
  background: ${props => (props.bgColor ? props.bgColor : props.inActive ? '#FFE5E5' : '#EEF7EA')};
  color: ${props => (props.color ? props.color : props.inActive ? '#FF0000' : '#579836')};
  border-radius: 4px !important;
  /* cursor: pointer; */
`;
export const CustomButton = styled(Button)<IButtonProps>`
  box-sizing: border-box;
  border: 1px solid ${props => props.borderColor || 'transparent'};
  background: ${props => props.bgColor || '#EEF7EA'};
  color: ${props => props.color || '#579836'};
  cursor: pointer;
  border-radius: ${props =>
    props.pillShape === true
      ? '25px'
      : props.roundedRect === true
        ? '5px'
        : props.borderRadius
          ? props.borderRadius
          : '4px'};
  &.status-btn {
    border-radius: 4px;
    min-width: 85px;
    font-size: ${props => props.fontSize || '16px'};
    font-weight: 600;
  }
  &.split-custom-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    color: #fff;
    padding-left: 25px;
    .fa-angle-down {
      font-size: 21px;
      margin-top: 2px;
    }
    .split-wrapper {
      height: inherit;
      display: flex;
      align-items: center;
      gap: 12px;
    }
  }
`;

// CSS for Button for Selecting Size
export const SelectSizeButton = styled(Button)<IButtonProps>`
  height: 40px;
  min-width: 100px;
  width: 100px;
  padding: 10px 15px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000;
`;

// CSS for Button with Icons

export const IconButton = styled(Button)<IButtonProps>`
  box-sizing: border-box;
  border: 1px solid ${info.dark};
  background: ${props => (props.primary ? accent.dark : common.white)};
  color: ${props => (props.primary ? common.white : info.dark)};
  cursor: pointer;
  padding: ${props => props.padding || '8px 12px'};
  height: ${props => props.height || '36px'};
  display: flex;
  align-items: ${props => props.alignItems || 'center'};
  justify-content: ${props => props.justifyContent || 'flex-start'};
  gap: ${props => props.gap || '9px'};
  border-radius: ${props => props.borderRadius || '0px'};
  &.transparent-btn {
    border: none;
    color: #555;
  }
  &.blue-btn-green-hovered {
    background: #f8f8f8;
    color: #555;
    border: 1px solid #aaa;
    height: 50px;
    border-radius: 10px;
    &.active {
      background: #f7fff3;
      color: #555;
      border: 1px solid #57ac2d;
    }
    img {
      height: 25px;
      width: 25px;
    }
    span {
      font-weight: 400;
    }
  }
  img,
  label {
    cursor: pointer;
  }
`;

export const LibraryButtons = styled(Button)<IButtonProps>`
  min-width: 100px;
  width: auto;
  text-align: center;
  height: 30px;
  border-radius: 10px;
  color: #555;
  border: none;
  background-color: #fff;
  display: flex;
  gap: 10px;
  line-height: 25px;
  padding: 4px 0px;
  font-size: 14px;
  font-weight: 600;
  img {
    height: 23px;
    width: 26px;
  }
  &.active {
    border: 1px solid #57ac2d;
    background-color: #f7fff3;
  }
  &.ap-upload-btn {
    line-height: 26px;
    img {
      height: 22px;
      width: 31px;
    }
  }
`;
